"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressValue = exports.AddressType = void 0;
const address_1 = require("../../address");
const types_1 = require("./types");
class AddressType extends types_1.PrimitiveType {
    constructor() {
        super("Address");
    }
    getClassName() {
        return AddressType.ClassName;
    }
}
exports.AddressType = AddressType;
AddressType.ClassName = "AddressType";
/**
 * An address fed to or fetched from a Smart Contract contract, as an immutable abstraction.
 */
class AddressValue extends types_1.PrimitiveValue {
    constructor(value) {
        super(new AddressType());
        this.value = new address_1.Address(value.bech32());
    }
    getClassName() {
        return AddressValue.ClassName;
    }
    /**
     * Returns whether two objects have the same value.
     *
     * @param other another AddressValue
     */
    equals(other) {
        return this.value.equals(other.value);
    }
    valueOf() {
        return this.value;
    }
}
exports.AddressValue = AddressValue;
AddressValue.ClassName = "AddressValue";
